import { render, staticRenderFns } from "./ReservationDetails.vue?vue&type=template&id=157d6977&scoped=true&"
import script from "./ReservationDetails.vue?vue&type=script&lang=js&"
export * from "./ReservationDetails.vue?vue&type=script&lang=js&"
import style0 from "./ReservationDetails.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ReservationDetails.vue?vue&type=style&index=1&id=157d6977&scoped=true&lang=css&"
import style2 from "./ReservationDetails.vue?vue&type=style&index=2&id=157d6977&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157d6977",
  null
  
)

export default component.exports